import { Component, HostListener, inject, OnInit } from '@angular/core';

import {
  CarouselComponent,
  GridComponent,
  ImageItem,
} from '@geekeno/ngx-website/components';
import { UtilsService } from '@geekeno/ngx-website/services';
import { Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faBullhorn,
  faGlobe,
  faPaintBrush,
  faPalette,
  faMobile,
  faVideo,
  faIdCard,
  faCalendarAlt,
  faRocket,
  faImages,
  faBoxesStacked,
  faReceipt,
  faLineChart,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';
import { LazyVideoComponent } from '../lazy-video/lazy-video.component';

@Component({
  selector: 'app-about',
  imports: [
    GridComponent,
    CarouselComponent,
    FaIconComponent,
    LazyVideoComponent,
  ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent implements OnInit {
  private utils = inject(UtilsService);
  private router = inject(Router);

  ngOnInit() {
    if (this.utils.isPlatformBrowser) {
      this.onWindowResize({});
    }
  }
  projects = [
    {
      title: 'MadBom Website',
      category: 'Website Development',
      imageUrl: '/assets/about/MadBom Website.avif',
      videoUrl: '/assets/about/Development/MadBom Website.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: 'Susheela Homes',
      category: 'Brochure Design',
      imageUrl: '/assets/about/Susheela Homes Brochure Design.avif',
      videoUrl: '/assets/about/Susheela Home Brochure Design.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: 'Kiran Trek Tour Website',
      category: 'Website Development',
      imageUrl: '/assets/about/Kiran Trek Tour Website.avif',
      videoUrl: '/assets/about/Development/Kiran Trek Tour Website.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: 'Rodrigues Wines',
      category: 'Website Development',
      imageUrl: '/assets/about/Rodrigues Wines Website.avif',
      videoUrl: '/assets/about/Development/Rodrigues Wines Website.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: "Mamma's Corner",
      category: 'Social Media',
      imageUrl: '/assets/about/Mamma-Corner Social-Media- Management.avif',
      videoUrl: "/assets/about/Mamma's Corner Social Media Management.mp4",
      id: this.utils.generateRandomId(),
    },
    {
      title: 'Acoustic Technik',
      category: 'Logo Design',
      imageUrl: '/assets/about/Acoustic Technik Logo Design.avif',
      id: this.utils.generateRandomId(),
      alt: 'Mockups of the logo designed for Acoustic Technik',
    },
    {
      title: 'Daniel DCosta Photography',
      category: 'Website Development',
      imageUrl: '/assets/about/Daniel DCosta Photography Website.avif',
      videoUrl:
        '/assets/about/Development/Daniel DCosta Photography Website.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: 'The Pier',
      category: 'Social Media',
      imageUrl: '/assets/about/The Pier Social Media Management.avif',
      videoUrl: '/assets/about/The Pier Social Media Management.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: 'Escape Goa',
      category: 'Website Development',
      imageUrl: '/assets/about/Escape Goa Website Development.avif',
      videoUrl: '/assets/about/Escape Goa Website Development.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: "Mum's Kitchen",
      category: 'Video Editing',
      imageUrl: '/assets/about/Mum-Kitchen Video-Editing.avif',
      videoUrl: '/assets/about/Mum-Kitchen Video-Editing.mp4',
      id: this.utils.generateRandomId(),
    },
    {
      title: '13 Sky',
      category: 'Logo Design',
      imageUrl: '/assets/about/13 Sky Logo Design.avif',
      alt: 'Mockups of the logo designed for 13 Sky',
      id: this.utils.generateRandomId(),
    },
    {
      title: 'Indian Coast Guard',
      category: 'Video Editing',
      imageUrl: '/assets/about/Indian-Coast-Guard-Video-Editing.avif',
      videoUrl: '/assets/about/Indian-Coast-Guard-Video-Editing.mp4',
      id: this.utils.generateRandomId(),
    },
  ];
  filteredProjects = [...this.projects];
  activeCategory: string = 'Show All';

  filterProjects(category: string): void {
    this.activeCategory = category;

    if (category === 'Show All') {
      this.filteredProjects = this.shuffleArray([...this.projects]);
    } else {
      this.filteredProjects = this.projects.filter(
        (project) => project.category === category,
      );
    }
  }

  shuffleArray(array: any[]): any[] {
    let shuffledArray = array
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
    return [...shuffledArray];
  }

  clients: ImageItem[] = [
    {
      src: '/assets/about/clients/bullion.avif',
      alt: 'The Bullion Bar & Bistro',
      type: 'image',
      heightInPx: 260,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/vibrance-world.avif',
      alt: 'Vibrance World',
      type: 'image',
      heightInPx: 260,
      widthInPx: 460,
    },
    {
      src: '/assets/about/clients/sheela.avif',
      alt: 'Sheela Restaurant & Bar',
      type: 'image',
      heightInPx: 260,
      widthInPx: 260,
    },
    {
      src: '/assets/about/clients/city-aluminium.png',
      alt: 'City Aluminium',
      type: 'image',
      heightInPx: 260,
      widthInPx: 260,
    },
    {
      src: '/assets/about/clients/the-shore-agonda.png',
      alt: 'The Shore Agonda',
      type: 'image',
      heightInPx: 260,
      widthInPx: 260,
    },
    {
      src: '/assets/about/clients/Lions_Clubs_International_logo.avif',
      alt: 'Lions Clubs International',
      type: 'image',
      heightInPx: 187,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/madhu-huts-agonda.png',
      alt: 'Madhu Huts Agonda',
      type: 'image',
      heightInPx: 126,
      widthInPx: 300,
    },
    {
      src: '/assets/about/clients/rodrigues-wines.avif',
      alt: 'Rodrigues Wines & General Stores',
      type: 'image',
      heightInPx: 200,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/origin_logo.png',
      alt: 'Origin Markets',
      type: 'image',
      heightInPx: 25,
      widthInPx: 300,
      onClick: (item) => {
        this.router.navigateByUrl(
          '/blog/origin-markets-revolutionising-debt-capital-markets',
        );
      },
    },
    {
      src: '/assets/about/clients/madbom.avif',
      alt: 'MadBom',
      type: 'image',
      heightInPx: 200,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/big-choice-furniture.png',
      alt: 'Big Choice Furniture',
      type: 'image',
      heightInPx: 200,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/susheela-homes.avif',
      alt: 'Susheela Homes',
      type: 'image',
      heightInPx: 114,
      widthInPx: 480,
      onClick: (item) => {
        this.router.navigateByUrl(
          '/blog/case-study-transforming-susheela-homes-real-estate-presence',
        );
      },
    },
    {
      src: '/assets/about/clients/Mums-Kitchen-Logo.avif',
      alt: "Mum's Kitchen",
      type: 'image',
      heightInPx: 200,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/chaat-di-hatti.avif',
      alt: 'Chaat Di Haati',
      type: 'image',
      heightInPx: 172,
      widthInPx: 300,
    },
    {
      src: '/assets/about/clients/fodni.webp',
      alt: 'Fodni - Flavours of Goa',
      type: 'image',
      heightInPx: 125,
      widthInPx: 250,
    },
    {
      src: '/assets/about/clients/Indian_Coast_Guard_Logo.avif',
      alt: 'Indian Coast Guard',
      type: 'image',
      heightInPx: 286,
      widthInPx: 240,
    },
    {
      src: '/assets/about/clients/dr-subash-homeopathy.png',
      alt: "Doctor Subash's Homeopathy",
      type: 'image',
      heightInPx: 105,
      widthInPx: 260,
    },
    {
      src: '/assets/about/clients/1111-athleisure.png',
      alt: '11 11 Athleisure',
      type: 'image',
      heightInPx: 126,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/mosh-logo.svg',
      alt: 'Mosh by the Shore',
      type: 'image',
      heightInPx: 150,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/wildernest.png',
      alt: 'Wildernest',
      type: 'image',
      heightInPx: 74,
      widthInPx: 270,
    },
    {
      src: '/assets/about/clients/casa-nova.avif',
      alt: 'Casanova',
      type: 'image',
      heightInPx: 217,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/agonda-island-view.png',
      alt: 'agonda-island-view',
      type: 'image',
      heightInPx: 205,
      widthInPx: 246,
    },
    {
      src: '/assets/about/clients/CJ-Academy.avif',
      alt: 'CJ-Academy',
      type: 'image',
      heightInPx: 200,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/Madame-Rosa.avif',
      alt: 'Madame-Rosa',
      type: 'image',
      heightInPx: 280,
      widthInPx: 280,
    },
    {
      src: '/assets/about/clients/Beyond-Space.avif',
      alt: 'Beyond-Space',
      type: 'image',
      heightInPx: 168,
      widthInPx: 200,
    },
    {
      src: '/assets/about/clients/escape-goa.avif',
      alt: 'Escape-Goa',
      type: 'image',
      heightInPx: 280,
      widthInPx: 280,
    },
    {
      src: '/assets/about/clients/Rachana Infotech.png',
      alt: 'Rachana-Infotech',
      type: 'image',
      heightInPx: 200,
      widthInPx: 200,
      onClick: (item) => {
        this.router.navigateByUrl(
          '/blog/case-study-website-revamp-for-rachana-infotech',
        );
      },
    },
    {
      src: '/assets/about/clients/The-Pier-Seaside-Bistro.png',
      alt: 'The-Pier-Seaside-Bistro',
      type: 'image',
      heightInPx: 168,
      widthInPx: 200,
      onClick: (item) => {
        this.router.navigateByUrl(
          '/blog/transforming-the-pier-seaside-bistros-digital-presence',
        );
      },
    },
  ];
  numberOfClientsPerRow = 2;
  numberOfClientRows = 2;
  autoScrollClients = true;

  services = [
    {
      title: 'Digital Marketing',
      description:
        'Boost your online visibility with SEO, social media campaigns, and performance-driven strategies tailored for businesses in Goa and across India.',
      url: '/services/digital-marketing',
      iconClass: faBullhorn,
    },
    {
      title: 'Website Development',
      description:
        'We build custom websites optimized for speed, mobile responsiveness, and SEO — designed to reflect your brand and convert visitors into customers.',
      url: '/services/website-development',
      iconClass: faGlobe,
    },
    {
      title: 'UI/UX Design',
      description:
        'Craft intuitive interfaces and seamless user journeys that elevate your digital product experience and drive user engagement across platforms.',
      url: '/services/website-development',
      iconClass: faPaintBrush,
    },
    {
      title: 'Graphic Designing',
      description:
        'From logo creation to brochure design, we deliver visuals that resonate with your brand and leave lasting impressions on your audience.',
      url: '/services/graphic-designing',
      iconClass: faPalette,
    },
    {
      title: 'Application Development',
      description:
        'Build scalable, secure mobile apps and enterprise software tailored to your business needs — from concept to deployment.',
      url: '/services/website-development',
      iconClass: faMobile,
    },
    {
      title: 'Video Production & Editing',
      description:
        'Create engaging video content that tells your story, builds trust, and drives action across platforms like YouTube, Instagram, and LinkedIn.',
      url: '/services/video-production',
      iconClass: faVideo,
    },
  ];

  icons = {
    palette: faPalette,
    idCard: faIdCard,
    images: faImages,
    calendar: faCalendarAlt,
    rocket: faRocket,
    inventory: faBoxesStacked,
    expense: faReceipt,
    analytics: faLineChart,
    budget: faWallet,
  };

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    // These values are taken from bulma after applying any overrides we have
    const gap = 32;
    const tabletMinWidth = 768;
    const desktopMinWidth = 960 + 2 * gap;
    if (window.innerWidth < tabletMinWidth) {
      // is Mobile
      this.numberOfClientsPerRow = 2;
      this.numberOfClientRows = 2;
      this.autoScrollClients = true;
    } else if (window.innerWidth < desktopMinWidth) {
      // is Tablet
      this.numberOfClientsPerRow = 5;
      this.numberOfClientRows = 2;
      this.autoScrollClients = true;
    } else {
      // is Desktop or larger (we have a max width on the carousel)
      this.numberOfClientsPerRow = 7;
      this.numberOfClientRows = 4;
      this.autoScrollClients = false;
    }
  }
}
